import React from "react";
import { graphql } from "gatsby";
import Copy from "../components/sections/Copy";
import Heading from "../components/sections/Heading";
import Hero from "../components/sections/Hero";
import LeftImageText from "../components/sections/LeftImageText";
import RightImageText from "../components/sections/RightImageText";
import LivHowItWorksSection from "../components/sections/LivHowItWorks";
import FullWidthImage from "../components/sections/FullWidthImage";
import FullHeightImage from "../components/sections/FullHeightImage";
import ListItemLink from "../components/sections/ListItemLink";
import Video from "../components/modules/Video";
import VideoFullWidth from "../components/modules/VideoFullWidth";
import LivNewsletter from "../components/sections/LivNewsletter";
import LivProForm from "../components/sections/LivProForm";
import FaqCategoryTitle from "../components/sections/LivFaq";
import CtaButton from "../components/sections/CtaButton";
import CarouselWithImageCardSlider from "../components/sections/CarouselWithImageSlider";
import CarouselWithReviewCardSlider from "../components/sections/CarouselWithReviewSlider";
import CtaBar from "../components/sections/CtaBar";
import HubspotForm from "../components/sections/HubspotForm";
import SEO from "../components/seo";
import Impact from "../components/impact/universalTracking";

export default function LivPage({ data }) {
  const pageContent = data.datoCmsLivPage.pageContent;
  const faqItems = data.datoCmsLivPage.faqItems;
  const trimmedPageContent = pageContent.filter((page) => page.internal);
  const trimmedFaqItems = faqItems.filter((page) => page.internal);

  const getComponentFromBlockType = (blockType) => {
    const components = {
      Copy,
      Heading,
      Hero: Hero,
      LeftImageText,
      RightImageText,
      LivHowItWorksSection,
      LivNewsletter,
      LivProForm,
      FaqCategoryTitle,
      FullWidthImage,
      FullHeightImage,
      ListItemLink,
      Video,
      VideoFullWidth,
      CtaButton,
      CarouselWithImageCardSlider,
      CarouselWithReviewCardSlider,
      CtaBar,
      HubspotForm,
    };

    const componentToRender = components[blockType.split("DatoCms")[1]];

    return componentToRender;
  };

  const renderLivPageContent = (pageContent, customClass) => {
    return (
      <div>
        {pageContent.map((item, index) => {
          const blockType = item.internal.type;
          const Component = getComponentFromBlockType(blockType);
          if (!Component) {
            return <></>;
          }

          const key = index;

          return (
            <Component
              key={key}
              customClass={customClass}
              data={item}
              field={blockType}
            />
          );
        })}
      </div>
    );
  };

  const renderLivFaqItems = (faqItems, customClass) => {
    return (
      <div>
        {faqItems.map((item, index) => {
          const blockType = item.internal.type;
          const Component = getComponentFromBlockType(blockType);

          if (!Component) {
            return <></>;
          }

          const key = index;
          return (
            <Component
              key={key}
              customClass={customClass}
              data={faqItems}
              field={blockType}
            />
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Impact />
      <SEO title={data.datoCmsLivPage.title} description={data.datoCmsLivPage.description} />
      <div className="LivPage">
        {renderLivPageContent(trimmedPageContent, "liv-system")}
        {renderLivFaqItems(trimmedFaqItems, "")}
      </div>
    </>
  );
}

export const query = graphql`
  query livPageAndLivPage {
    datoCmsLivPage {
      title
      description
      locale
      pageContent {
        ...HeadingComponent
        ...CopyComponent
        ...HeroComponent
        ...FullWidthImageComponent
        ...FullHeightImageComponent
        ...LeftImageTextComponent
        ...RightImageTextComponent
        ...LivHowItWorksSectionComponent
        ...ListItemLinkComponent
        ...LivNewsletterComponent
        ...LivProFormComponent
        ...CtaButtonComponent
        ...VideoFullWidthComponent
        ...CarouselWithImageCardSlider
        ...CarouselWithReviewCardSlider
        ...CtaBarComponent
        ...HubspotFormComponent
      }
      faqItems {
        ... on DatoCmsFaqCategoryTitle {
          internal {
            type
          }
          categoryTitle
        }
        ... on DatoCmsFaqItem {
          internal {
            type
          }
          question
          answer
        }
      }
    }
  }
`;
